import { CityResponse, ProfileViewResponse } from "@/generated-api";
import BadgeWithFlag from "./BadgeWithFlag";
import BadgeWithImage from "./BadgeWithImage";
import pinWhite from "../../assets/pin-white.svg";
import { mapAlpha2 } from "@/lib/utils";

function locationName(city: CityResponse) {
  const parts = [city.name, city.state, mapAlpha2(city.country.alpha_2)].filter(
    Boolean
  );
  return parts.join(", ");
}

export default function NationalityLocation({
  profileView,
}: {
  profileView: ProfileViewResponse;
}) {
  return (
    <div className="flex flex-wrap w-full gap-x-3 gap-y-4">
      <BadgeWithFlag
        flagCode={profileView.nationality.alpha_2}
        title={profileView.nationality.nationality}
      />
      <BadgeWithImage
        image={<img src={pinWhite} className="h-5 w-5" />}
        title={locationName(profileView.primary_city)}
      />
      {profileView.secondary_city && (
        <BadgeWithImage
          image={
            <div className="relative inline-block">
              <img src={pinWhite} className="h-5 w-5 mr-2" />
              <span className="absolute top-0 right-0 text-xs -mt-1">2</span>
            </div>
          }
          title={locationName(profileView.secondary_city)}
        />
      )}
    </div>
  );
}
